if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
    }

    connectedCallback() {
      this.initSlider(this.swiperOptions);
      this._unbindEditor = ThemeEditor.bind(this, () => this.initSlider(this.swiperOptions));
    }

    disconnectedCallback() {
      this._unbindEditor?.();
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider(swiperOptions) {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
          }
        }
      };

      this.slider = ThemeEditor.initSwiper(this, sliderOptions);
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
